import React, { Component } from "react";
import "./DelIcon.css";
import "../Styles/SvgCommand.css";

const DelIcon = (props) => {
  return (
    <svg
      id="Layer_1"
      version="1.1"
      viewBox="0 0 100 100"
      height="17px"
      width="17px"
      className="svgPolygon"
    >
      <polygon points="77.6,21.1 49.6,49.2 21.5,21.1 19.6,23 47.6,51.1 19.6,79.2 21.5,81.1 49.6,53 77.6,81.1 79.6,79.2   51.5,51.1 79.6,23 " />
    </svg>
  );
};

export default DelIcon;
